import React from 'react';
import PropTypes from 'prop-types';
import { Map } from 'immutable';

import Accordion from '@Components/Accordion';
import Input from '@Components/Input';

import InputToggler from './InputToggler';
import ViewMoreToggler from './ViewMoreToggler';
import EditToggler from './EditToggler';

export default function BarChartFilterControls(props) {
  const { filter, onInputChange } = props;
  const userInputOpen = filter.get('userInputOpen');
  const userInputValue = filter.get('userInputValue');
  const numeric = filter.get('numeric');

  return (
    <section className="bar-chart-filter-controls">
      <div className="bar-chart-filter-controls-togglers-wrapper">
        <InputToggler {...props} />
        <ViewMoreToggler {...props} />
        <EditToggler {...props} />
      </div>
      <Accordion
        className="bar-chart-filter-controls-input-wrapper"
        open={userInputOpen}
        content={
          <Input
            value={userInputValue}
            className="bar-chart-filter-controls-input"
            placeholder={numeric ? 'Enter any number or range' : 'Enter any text'}
            onChange={onInputChange}
            type="text"
          />
        }
      />
    </section>
  );
}

BarChartFilterControls.propTypes = {
  filter: PropTypes.instanceOf(Map).isRequired,
  disableViewMore: PropTypes.bool.isRequired,
  onInputChange: PropTypes.func.isRequired,
  onClickViewMore: PropTypes.func.isRequired,
  onClickUserInput: PropTypes.func.isRequired,
  canRenderViewMore: PropTypes.bool.isRequired,
  disableUserInputToggler: PropTypes.bool.isRequired,
};
